import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.04 4H2.02V2.02H7V4H4V7H2.04V4ZM4 17H2.02V21.98H7V20H4V17ZM20.04 7H21.98V2H17V3.98H20.04V7ZM21.99 17H19.99V20H16.99V21.98H22V20H21.99V17ZM11 2H9V4H11V2ZM15 2H13V4H15V2ZM3.96 9H2V11H3.96V9ZM3.96 13H2V15H3.96V13ZM20 9V11H22V9H20ZM20 15H22V13H20V15ZM9 22H11V20H9V22ZM13 22H15V20H13V22ZM13 17V9H17V7H7V9H11V17H13Z" fill={ fill || 'currentColor' } />
    </svg>
);
